import React, {Component, Fragment, useEffect, useState} from 'react'
import {ASSET_URL} from "../../../config";

export default function VideoPlayer({context,campagneData,campagneTarget}) {

    if(campagneData?.config["ald.leftBanner"])
    {
        return (
            <img src={ASSET_URL+"/"+campagneData.config["ald.leftBanner"]} style={{width:"100%",maxHeight:"100%", borderRadius: 5,objectFit:"cover"}}/>
        )
    }

    return (
        <iframe
            src={"https://www.youtube.com/embed/" + campagneData.config["banners.youtube"] + "?&rel=0&playsinline=1&iv_load_policy=3&modestbranding=1&enablejsapi=1&widgetid=1&mute=0&loop=1"}
            style={{minHeight: context.isMobile ? 300 : "100%", width: "100%", borderRadius: 5}}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
        />
    )
}
